

export const pizzaData = [
   {
    name: "Pizza Margherita",
    ingredients: "Our signature dough melds perfectly with our house marinara sauce and fresh mozarella cheese. Topped with basil and olive oil to finish",
    price: 22,
    photoName: "menu/margherita.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Pizza Spinaci",
    ingredients: "A classic pizza topped with our house marinara sauce, mozarella cheese, and spinach",
    price: 22,
    photoName: "menu/spinaci.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Pizza Funghi",
    ingredients: "We craft a fresh pizza dough and top it with our house marinara sauce, mozarella cheese, and a selection of local mushrooms and truffles",
    price: 28,
    photoName: "menu/funghi.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Pizza Salamino",
    ingredients: "The classic pizza with our house marinara sauce, mozarella cheese, and pepperoni",
    price: 28,
    photoName: "menu/salamino.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Pizza Prosciutto",
    ingredients: "Fresh meat comes from local farms and is sliced daily. We top our signature pizza dough with our house marinara sauce, mozarella cheese, and prosciutto",
    price: 30,
    photoName: "menu/prosciutto.jpg",
    soldOut: false,
    inCart: false,
  },
];

export const mainDishData = [
  {
    name: "Chicken Parmesan",
    ingredients: "Our Chicken's come fresh from local farms every morning. We bread them with our signature seasonings and fry them to perfection. Served on a bed of hand made spaghetti and topped with our house marinara sauce",
    price: 24,
    photoName: "menu/chicken-parm.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Spaghetti Carbonara",
    ingredients: "Hand rolled spaghetti cooked with locally sourced bacon, parmesan cheese, and egg yolk",
    price: 24,
    photoName: "menu/carbonara.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Risotto Ai Funghi",
    ingredients: "Freshly made risotto with hand picked mushrooms, truffle oil, and melted parmesan cheese",
    price: 28,
    photoName: "menu/mushroom-risotto.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Melanzane alla Parmigiana",
    ingredients: "Fresh picked aubergine, thinly sliced and breaded with our signature seasonings. Fried to perfection and topped with our house marinara sauce and mozarella cheese",
    price: 22,
    photoName: "menu/melanzane.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Vitello Tonnato",
    ingredients: "Our veal is sourced from local farms and sliced daily. We top it with a special tuna sauce, capers, and lemon slices",
    price: 22,
    photoName: "menu/vitello.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Pan Baked Lasagna",
    ingredients: "We make out pasta fresh daily, layering it 10 times with our signature marinara sauce, mozarella cheese, and ground beef. Baked to perfection in a cast iron pan and served with a side of garlic bread",
    price: 24,
    photoName: "menu/lasagna.jpg",
    soldOut: false,
    inCart: false,
  },
];

export const appetizerData = [
  {
    name: "Focaccia",
    ingredients: "Our famous pizza dough baked with italian olive oil and rosemary",
    price: 9,
    photoName: "menu/focaccia.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Avocado Bruschetta",
    ingredients: "Home made bread freshly toasted with avocado, tomatoes, basil, and our signature olive oil",
    price: 12,
    photoName: "menu/bruschetta.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Caesar Salad",
    ingredients: "Fresh romaine lettuce, croutons, parmesan cheese, and our chef's special caesar dressing",
    price: 12,
    photoName: "menu/caesar-salad.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Mozzarella Sticks",
    ingredients: "Our Signature seasonings mixed with home made bread crumbs and mozzarella cheese, fried to perfection. Served with house marinara sauce",
    price: 10,
    photoName: "menu/mozzarella-sticks.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Carbonara Arancini",
    ingredients: "Crispy fried risotto balls filled with bacon, parmesan cheese, and fresh noodles. Served with house marinara sauce",
    price: 12,
    photoName: "menu/arancini.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Antipasto Board",
    ingredients: "An assortment of italian meat, cheese, olives, peppers, and asparagus. Served with a side of our signature bread",
    price: 16,
    photoName: "menu/antipasto.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Eggplant Caponata",
    ingredients: "Fresh eggplant, celery, and capers cooked in a sweet and sour sauce and topped with fresh mozzarella cheese. Served with a side of our signature bread",
    price: 12,
    photoName: "menu/caponata.jpg",
    soldOut: false,
    inCart: false,
  },
];

export const dessertData = [
  {
    name: "Blackberry Tiramisu",
    ingredients: "Delicate ladyfingers, mascarpone cream, and blackberries. Beautifully layered and perfect for summer",
    price: 14,
    photoName: "menu/tiramisu.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Banana Creme Cannoli",
    ingredients: "Fried pastry shell with a sweet ricotta filling and a hint of banana puree",
    price: 14,
    photoName: "menu/cannoli.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Panna Cotta",
    ingredients: "Sweetened cream with gelatin and molded into a custard. Served with a fresh baked ladyfinger",
    price: 12,
    photoName: "menu/panna-cotta.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Daily Fresh Gelato",
    ingredients: "Our always changing flavour of home made gelato. Served in a fresh waffle cone",
    price: 9,
    photoName: "menu/gelato.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Elderberry Cheesecake",
    ingredients: "Local Elderberry compote on top of a creamy marscapone cheesecake. Served with a side of fresh whipped cream",
    price: 15,
    photoName: "menu/cheesecake.jpg",
    soldOut: false,
    inCart: false,
  },
  {
    name: "Raspberry Almond Tart",
    ingredients: "A fresh tart shell with a sweet Almond glaze, topped with fresh raspberries and a hint of lemon zest",
    price: 12,
    photoName: "menu/almond-tart.jpg",
    soldOut: false,
    inCart: false,
  },
];
